(function () {
  if (window.customElements && customElements.get('active-facets-equalize')) {
    return;
  }

  var RESIZE_DEBOUNCE_MS = 120;

  class ActiveFacetsEqualize extends HTMLElement {
    constructor() {
      super();
      this._scheduled = false;
      this._onResize = this._onResize.bind(this);
      this._equalize = this._equalize.bind(this);
    }

    connectedCallback() {
      this._observer = new MutationObserver(() => this._schedule());
      this._observer.observe(this, { childList: true, subtree: true, characterData: true });
      window.addEventListener('resize', this._onResize);
      requestAnimationFrame(this._equalize);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this._equalize).catch(function () {});
      }
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      window.removeEventListener('resize', this._onResize);
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
    }

    _onResize() {
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this._equalize, RESIZE_DEBOUNCE_MS);
    }

    _schedule() {
      if (this._scheduled) return;
      this._scheduled = true;
      requestAnimationFrame(() => {
        this._scheduled = false;
        this._equalize();
      });
    }

    _equalize() {
      var chips = this.querySelectorAll('.removable-facet');
      if (!chips.length) {
        this.style.removeProperty('--enchliving-active-control-width');
        return;
      }

      this.style.removeProperty('--enchliving-active-control-width');

      var max = 0;
      for (var i = 0; i < chips.length; i++) {
        var w = chips[i].getBoundingClientRect().width;
        if (w > max) max = w;
      }

      if (max > 0) {
        this.style.setProperty('--enchliving-active-control-width', Math.ceil(max) + 'px');
      }
    }
  }

  customElements.define('active-facets-equalize', ActiveFacetsEqualize);
})();
